export default __webpack_public_path__ + "static/media/logoSOAI_Plan de travail 1.16c1886b.png";